import ExternalTour from './ExternalTour';
import VrModel from './VrModel';

const Unit = ({
  id = '',
  name = '',
  active = false,
  dateAvailable = '',
  squareFeet = '',
  vrModel = {},
  videoUrl = '',
  price = '',
  externalTour = {},

  // legacy/deprecated
  unitId = '',
  lowPrice = '',
} = {}) => ({
  id: String(id) || String(unitId),
  name: String(name),
  active: Boolean(active),
  dateAvailable: String(dateAvailable),
  price: String(price) || String(lowPrice),
  squareFeet: String(squareFeet),
  vrModel: VrModel(vrModel),
  videoUrl: String(videoUrl),
  externalTour: ExternalTour(externalTour),

  // deprecated
  unitId: String(unitId) || String(id), // same as `id`
});

export default Unit;

export type UnitProps = ReturnType<typeof Unit>;
